import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import ProjectCards from "./ProjectCards";

import Button from "react-bootstrap/Button";
import { FaArrowRight } from "react-icons/fa";

// 示例数据，请替换成你自己的视频和封面路径
const projectData = [
  {
    title: "医美科普 | 抗炎水光",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/01%E6%96%B0%E6%B0%A7%E6%8A%97%E7%82%8E.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/01.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
      "Adobe Photoshop",
      "DaVinci Resolve",
      "剪映",
    ],
    description: {
      intro: "新氧公司旗下“迷死氧实验室”科普账号",
      style: "动效制作 / 素材混剪 / 实拍采访",
    },
    demoLink: "https://work.wujiayi.vip",
    disabled: true,
  },

  {
    title: "商业人物 | 段永平小传",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/03%E5%98%89%E5%AE%BE%E5%B0%8F%E6%AE%B5.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/02.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
      "Adobe Photoshop",
      "剪映",
    ],
    description: {
      intro: "“嘉宾商学”账号人物小传系列",
      style: "动效制作 / 素材混剪",
    },
    demoLink: "https://v.douyin.com/iliD-YegHX0/",
  },

    {
    title: "商业财经 | 离岸人民币",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/02%E8%99%8E%E5%97%85%E7%A6%BB%E5%B2%B8.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/03.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
      "Adobe Photoshop",
      "剪映",
    ],
    description: {
      intro: "“虎嗅”账号十里堡嗅财系列",
      style: "动效制作 / 素材混剪",
    },
    demoLink: "https://www.bilibili.com/video/BV1BX4y1Y7vN/",
  },

  {
    title: "Vlog | 沈奕斐美国访学日常",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/07.%E3%80%90%E6%B1%BD%E8%BD%A6%E5%95%86%E5%8D%95%E3%80%91%E5%8D%9A%E4%B8%BB%E6%B2%88%E5%A5%95%E8%8F%B2%EF%BC%9A%E6%B2%83%E5%B0%94%E6%B2%83%E5%95%86%E5%8D%95.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/04.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
      "剪映",
    ],
    description: {
      intro: "新世相签约博主沈奕斐账号，沃尔沃商单",
      style: "视频包装 / 实拍素材",
    },
    demoLink: "https://www.bilibili.com/video/BV1LG411r7AB/",
  },

  {
    title: "课程 | 沈奕斐的爱情思维课",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/10.%E3%80%90%E8%AF%BE%E7%A8%8B%E3%80%91%E6%B2%88%E5%A5%95%E6%96%90%E3%80%8A%E7%88%B1%E6%83%85%E6%80%9D%E7%BB%B4%E8%AF%BE%20-%20%E5%BD%A9%E8%9B%8B%E8%AF%BE%E3%80%8B.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/05.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
      "Adobe Photoshop",
      "DaVinci Resolve",
      "剪映",
    ],
    description: {
      intro: "新世相签约博主沈奕斐账号，付费课程",
      style: "课程包装 / 实拍素材",
    },
    demoLink: "https://work.wujiayi.vip",
    disabled: true,
  },

  /*{
    title: "自制 | 新疆的煤点亮上海的灯",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/06.%E3%80%90%E7%A7%91%E6%99%AE%E3%80%91%E8%87%AA%E5%88%B6%EF%BC%9A%E6%96%B0%E7%96%86%E7%9A%84%E7%85%A4%E5%A6%82%E4%BD%95%E7%82%B9%E4%BA%AE%E4%B8%8A%E6%B5%B7%E7%9A%84%E7%81%AF.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/06.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
      "Cinema 4D",
    ],
    description: {
      intro: "独立写稿、配音、制作的科普视频",
      style: "文稿撰写 / 动效制作 / 素材混剪",
    },
    demoLink: "https://www.bilibili.com/video/BV1Z34y1Y76D/",
  },*/
  {
    title: "AI制作 | 猿辅导飞象星球",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/%E9%A3%9E%E8%B1%A1%E5%AF%BC%E5%87%BA.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/13.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
      "Midjourney",
      "即梦AI",
    ],
    description: {
      intro: "使用文生图AI工具生成动效素材",
      style: "动效制作 / AI工具",
    },
    demoLink: "https://work.wujiayi.vip",
    disabled: true,
  },

    {
    title: "医美科普 | 金茉4R胶原机",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/06.%E3%80%90%E5%8C%BB%E7%BE%8E%E5%95%86%E5%8D%95%E3%80%91%E6%96%B0%E6%B0%A7%EF%BC%9A%E9%87%91%E8%8C%89.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/07.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
      "剪映",
      "Sony A7M4",
    ],
    description: {
      intro: "“迷死氧实验室”科普账号，医美商单视频",
      style: "动效制作 / 素材混剪 / 实拍素材",
    },
    demoLink: "https://www.bilibili.com/video/BV1LfzqYiEw6/",
  },

  {
    title: "科普 | 全球变暖是一场骗局",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/04.%E3%80%90%E7%9F%A5%E8%AF%86%E7%A7%91%E6%99%AE%E3%80%91%E8%A7%86%E7%9F%A5%EF%BC%9A%E5%85%A8%E7%90%83%E5%8F%98%E6%9A%96%E6%98%AF%E4%B8%80%E5%9C%BA%E9%AA%97%E5%B1%80%E5%90%97.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/08.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
    ],
    description: {
      intro: "“视知”账号的阴谋论解剖计划系列",
      style: "动效制作 / 素材混剪",
    },
    demoLink: "https://www.bilibili.com/video/BV1se4y1J7fo/",
  },

    {
    title: "商业故事 | 一颗印度小绿糖",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/7.%E3%80%90%E5%95%86%E4%B8%9A%E8%B4%A2%E7%BB%8F%E3%80%91%E4%B8%80%E9%A2%97%E5%8D%B0%E5%BA%A6%E5%B0%8F%E7%BB%BF%E7%B3%96%E5%A6%82%E4%BD%95%E5%88%9B%E9%80%A0%E6%B6%88%E8%B4%B9%E5%A5%87%E8%BF%B9.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/09.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
    ],
    description: {
      intro: "“钞能力毛毛”账号的财经泛科普系列",
      style: "动效制作 / 素材混剪",
    },
    demoLink: "https://www.bilibili.com/video/BV1DZ4y1D7K3/",
  },
    {
    title: "宣传片 | 军工仿真软件企业",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/10.%E3%80%90%E5%AE%A3%E4%BC%A0%E7%89%87%E3%80%91%E5%86%9B%E5%B7%A5%E8%BD%AF%E4%BB%B6%E4%BC%81%E4%B8%9A%E5%AE%A3%E4%BC%A0%E7%89%87.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/10.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Audition",
      "Adobe Media Encoder",
      "Adobe Illustrator",
      "DaVinci Resolve",
    ],
    description: {
      intro: "专注于军工仿真软件的企业宣传视频",
      style: "动效制作 / 素材混剪 / 实拍素材",
    },
    demoLink: "https://work.wujiayi.vip",
    disabled: true,
  },

  {
    title: "拍摄 | 飞驰人生",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/%E5%BC%80%E8%BD%A6.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/11.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Media Encoder",
      "DaVinci Resolve",
      "Sony A7M4",
      "DJI Action3",
      "DJI Mini4Pro",
    ],
    description: {
      intro: "每个男生都想在赛道上飞驰人生",
      style: "实拍素材 / 调色 / 剪辑",
    },
    demoLink: "https://work.wujiayi.vip",
    disabled: true,
  },

    {
    title: "拍摄 | 大爷的战场",
    videoSrc: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E4%BD%9C%E5%93%81%E9%9B%86/%E4%B8%8B%E6%A3%8B.mp4",
    poster: "https://wujiayi-work.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/12.png",
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "Adobe Media Encoder",
      "DaVinci Resolve",
      "Sony A7M4",
    ],
    description: {
      intro: "平静的公园也是大爷们充满硝烟的战场",
      style: "实拍素材 / 调色 / 剪辑",
    },
    demoLink: "https://work.wujiayi.vip",
    disabled: true,
  },
  // 你可以继续添加更多项目
];

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
           <h1 className="project-heading">
          我的<strong className="purple">视频项目</strong>
        </h1>
        <p style={{ color: "white" ,fontSize: "1.3em", marginTop: "20px"}}>
          以下是近期参与制作或独立完成的项目
        </p>   


        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href="https://pan.baidu.com/s/18Mu0_3_nrKxRhRVu2tyCBg?pwd=1111"
            target="_blank"
            rel="noreferrer"
            style={{
              margin: "20px auto",
              display: "block",
              letterSpacing: "1px",
              fontSize: "1.1rem",
              maxWidth: "250px",
            }}
          >
            <FaArrowRight style={{ marginRight: "6px" }} />
            在百度网盘查看
          </Button>
        </Row>

      <Container>


        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projectData.map((project, index) => (
            <Col md={6} lg={4} sm={12} key={index} className="project-card">
              <ProjectCards {...project} />
            </Col>
          ))}
        </Row>
      </Container>
              <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href="https://pan.baidu.com/s/18Mu0_3_nrKxRhRVu2tyCBg?pwd=1111"
            target="_blank"
            rel="noreferrer"
            style={{
              margin: "20px auto",
              display: "block",
              letterSpacing: "1px",
              fontSize: "1.1rem",
              maxWidth: "250px",
            }}
          >
            <FaArrowRight style={{ marginRight: "6px" }} />
            在百度网盘查看
          </Button>
        </Row>
    </Container>
  );
}

export default Projects;
